export const articles = [
  {
    id: 1,
    slug: 'japanese-skincare-routine-guide',
    title: '日本女生护肤秘籍：从卸妆到面霜的完整步骤解析',
    excerpt: '日本女生以精致护肤闻名世界，她们的多步骤护肤流程到底有什么秘密？本文为您详细拆解日式护肤的每一个环节，从双重清洁到层层保湿，带您了解日本女性保持肌肤水润透亮的完整秘诀。',
    content: `<p>日本女生的护肤流程在全球范围内都被视为精致护肤的典范。她们的护肤理念核心在于"层层叠加、循序渐进"，每一步都有其独特的作用和意义。</p>
<h3>第一步：卸妆（クレンジング）</h3>
<p>日本女生非常重视卸妆，无论多晚多累都不会跳过这一步。她们通常选择卸妆油或卸妆膏，因为这类产品能够彻底溶解彩妆和防晒产品，且不会过度拉扯肌肤。推荐产品：<strong>FANCL 无添加纳米卸妆油</strong>、<strong>植村秀洁颜油</strong>。</p>
<h3>第二步：洁面（洗顔）</h3>
<p>卸妆后使用温和的洁面产品进行二次清洁，确保毛孔中没有残留。日本女生偏爱泡沫丰富细腻的洁面产品，用手或起泡网打出绵密泡沫后再上脸，减少摩擦。推荐产品：<strong>CPB光采洁面膏</strong>、<strong>资生堂完美洁面乳</strong>。</p>
<h3>第三步：化妆水/爽肤水（化粧水）</h3>
<p>这是日式护肤中最关键的一步。日本女生会"层层拍水"，通常拍3-5层，让肌肤充分喝饱水。她们相信只有做好基础保湿，后续产品才能更好地吸收。推荐产品：<strong>SK-II神仙水</strong>、<strong>IPSA流金水</strong>。</p>
<h3>第四步：精华液（美容液）</h3>
<p>针对特定肌肤问题使用功能性精华，如美白、抗老、修复等。日本女生通常会同时使用2-3种精华，按照质地从轻薄到厚重的顺序叠加。推荐产品：<strong>资生堂红腰子精华</strong>、<strong>黛珂小紫瓶保湿精华</strong>。</p>
<h3>第五步：乳液/面霜（乳液・クリーム）</h3>
<p>锁住前面所有步骤的水分和营养，形成保护膜。日系乳液通常质地清爽，而面霜则更滋润。推荐产品：<strong>黛珂牛油果乳液</strong>、<strong>珂润保湿面霜</strong>。</p>
<h3>总结</h3>
<p>日本女生的护肤哲学是"预防大于修复"，她们从年轻开始就坚持完整的护肤流程，日积月累才能拥有令人羡慕的好肌肤。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20skincare%20routine%20products%20beautifully%20arranged%20on%20a%20minimal%20vanity%20table%2C%20soft%20natural%20light%2C%20warm%20cream%20background%2C%20elegant%20lifestyle%20photography%2C%20high%20quality%20editorial%20style&width=1200&height=675&seq=article-01&orientation=landscape',
    category: '美妆护肤',
    tags: ['护肤', '日式护肤', '美容'],
    publishedAt: '2026-07-28',
    readTime: '8分钟',
    isFeatured: true,
  },
  {
    id: 2,
    slug: 'top-10-japanese-snacks-must-try',
    title: '去日本必买的10款零食：从经典到小众的味觉之旅',
    excerpt: '日本零食以其精致的包装和独特的口味征服了全球吃货。本文精选10款必买日本零食，从北海道白色恋人到东京香蕉蛋糕，每一款都是味蕾的极致享受。',
    content: `<p>日本是零食爱好者的天堂，从便利店到百货商场地下食品街，琳琅满目的零食让人眼花缭乱。以下是我们精选的10款必买日本零食：</p>
<h3>1. 白色恋人（白い恋人）</h3>
<p>北海道最具代表性的伴手礼，酥脆的猫舌饼干夹着入口即化的白巧克力，甜而不腻。除了原味白巧克力，还有黑巧克力版本可供选择。</p>
<h3>2. ROYCE 生巧克力</h3>
<p>同样来自北海道的顶级巧克力品牌。生巧克力含水量高达17%以上，口感如丝绒般顺滑。推荐原味、抹茶和香槟口味。</p>
<h3>3. 东京香蕉（東京ばな奈）</h3>
<p>东京最具代表性的伴手礼之一，松软的海绵蛋糕包裹着顺滑的香蕉卡仕达酱，造型可爱，口感绵密。</p>
<h3>4. 卡乐比薯条三兄弟</h3>
<p>北海道限定产品，使用北海道产马铃薯，连皮切条油炸，保留了马铃薯最原始的风味，酥脆咸香，让人一根接一根停不下来。</p>
<h3>5. Pocky 格力高百奇</h3>
<p>日本国民零食，细长的饼干棒裹上各种口味的巧克力涂层。除了经典巧克力味，还有草莓、抹茶、杏仁等限定口味。</p>
<h3>6. KitKat 奇巧</h3>
<p>日本是全球KitKat口味最丰富的国家，有超过300种口味！推荐抹茶、草莓芝士蛋糕、日本酒和北海道哈密瓜等限定口味。</p>
<h3>7. 一兰拉面 速食版</h3>
<p>福冈著名拉面店一兰推出的速食版拉面，汤底浓郁，面条劲道，附带的秘制辣酱更是点睛之笔。在家就能还原一兰的经典味道。</p>
<h3>8. 亀田製菓 柿种</h3>
<p>日本人最爱的下酒零食之一，辣味脆米果搭配花生，口感香脆，越吃越上瘾。六小袋独立包装，便于携带和分享。</p>
<h3>9. 明治 杏仁巧克力</h3>
<p>整颗烤杏仁裹上明治优质牛奶巧克力，坚果的香脆与巧克力的丝滑完美融合，是日本超市最畅销的巧克力零食之一。</p>
<h3>10. UHA 味觉糖 コロロ</h3>
<p>UHA味觉糖出品的果汁软糖，口感如果实般Q弹多汁，果汁含量高，冷藏后食用口感更佳。推荐葡萄和桃子口味。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20Japanese%20snacks%20and%20sweets%20beautifully%20arranged%20on%20a%20minimal%20wooden%20table%2C%20various%20packaging%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20food%20photography%2C%20editorial%20style&width=1200&height=675&seq=article-02&orientation=landscape',
    category: '食品零食',
    tags: ['零食', '日本美食', '伴手礼'],
    publishedAt: '2026-07-25',
    readTime: '10分钟',
    isFeatured: true,
  },
  {
    id: 3,
    slug: 'japanese-home-organization-tips',
    title: '日式收纳美学：5个让家变整洁的日本收纳神器',
    excerpt: '日本人的收纳智慧闻名世界，他们将有限的空间利用到极致。本文介绍5款来自日本的收纳神器，帮您打造整洁有序的理想家居空间。',
    content: `<p>在日本这个土地资源有限的国家，收纳已经成为一门生活艺术。以下5款日本收纳神器，将帮助您轻松打造整洁有序的家居环境：</p>
<h3>1. 无印良品 PP收纳盒系列</h3>
<p>MUJI的PP收纳盒是日式收纳的代表之作。半透明材质一目了然，多种尺寸可自由组合叠加，无论是衣柜、厨房还是浴室都能完美适用。抽屉式设计让取用更加方便。</p>
<h3>2. 山崎实业 冰箱收纳盒</h3>
<p>日本主妇必备的冰箱收纳神器。透明设计便于查看食材余量，带手柄设计方便取放，可叠放设计充分利用冰箱纵向空间。从此告别冰箱杂乱无章的状态。</p>
<h3>3. 霜山 壁挂式收纳架</h3>
<p>充分利用墙面空间，将厨房用具、清洁工具悬挂收纳。免钉安装不伤墙面，承重力强，白色简约设计适合各种家居风格。</p>
<h3>4. NITORI 床下收纳箱</h3>
<p>日本最大的家居连锁品牌NITORI出品。扁长设计完美利用床下死角空间，带轮子方便推拉，适合存放换季衣物和被褥。</p>
<h3>5. 大创 分隔收纳盒</h3>
<p>百元店也能买到实用好物！大创的分隔收纳盒适合整理抽屉内的小物件，如内衣、袜子、文具等。可自由调节分隔板长度，灵活适配各种抽屉尺寸。</p>
<h3>日式收纳的三大原则</h3>
<p><strong>1. 断舍离：</strong>定期清理不需要的物品，只保留真正需要的。</p>
<p><strong>2. 物归原位：</strong>每件物品都有固定的"家"，使用后立即归位。</p>
<p><strong>3. 垂直空间利用：</strong>充分利用墙面和垂直空间，释放地面和桌面。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20home%20organization%20and%20storage%20solutions%20displayed%20in%20a%20minimal%20clean%20room%2C%20MUJI%20style%20storage%20boxes%2C%20warm%20cream%20background%2C%20natural%20lighting%2C%20interior%20photography&width=1200&height=675&seq=article-03&orientation=landscape',
    category: '家居日用',
    tags: ['收纳', '家居', '日式美学'],
    publishedAt: '2026-07-20',
    readTime: '7分钟',
    isFeatured: false,
  },
  {
    id: 4,
    slug: 'matcha-culture-guide',
    title: '抹茶控必读：从宇治到世界的日本抹茶文化全解析',
    excerpt: '抹茶不仅是一种饮品，更是日本文化的精髓。从宇治茶园的种植工艺到茶道中的禅意美学，本文带您深入了解日本抹茶的前世今生。',
    content: `<p>抹茶（Matcha）源自中国宋代，由日本僧侣带回并发展为独特的茶道文化。如今，抹茶已成为日本的象征之一，风靡全球。</p>
<h3>抹茶的起源与历史</h3>
<p>抹茶的制作工艺最早出现在中国宋代，当时称为"点茶"。12世纪末，日本僧侣荣西将茶种和点茶法带回日本，在京都附近的宇治地区开始种植。经过数百年的发展，抹茶逐渐从僧侣的修行饮品演变为武士阶层和贵族的文化象征，最终形成了独特的日本茶道。</p>
<h3>宇治：抹茶的圣地</h3>
<p>京都府宇治市是日本最著名的抹茶产地。宇治地区独特的气候条件——多雾湿润、昼夜温差大——为茶树提供了理想的生长环境。宇治抹茶以其深邃的绿色、细腻的质地和鲜美的回甘闻名于世。</p>
<h3>抹茶的制作工艺</h3>
<p>抹茶的制作极为讲究。在采摘前约20天，茶园会用遮光布覆盖茶树，减少阳光直射，促使茶叶产生更多的叶绿素和氨基酸（特别是茶氨酸）。采摘后，茶叶经过蒸青、干燥、去茎去脉，最后用石磨缓缓研磨成超细粉末。一台石磨每小时仅能研磨约40克抹茶，足见其珍贵。</p>
<h3>抹茶的等级</h3>
<p><strong> ceremonial级（茶道用）：</strong>最高等级，颜色翠绿，口感极其细腻，回甘悠长，用于正式茶道。</p>
<p><strong> premium级（饮品用）：</strong>中高等级，适合制作抹茶拿铁等饮品，风味平衡。</p>
<p><strong> culinary级（烘焙用）：</strong>适合用于烘焙、料理，茶味浓郁但苦涩感较强。</p>
<h3>推荐抹茶品牌</h3>
<p>• <strong>丸久小山園：</strong>宇治300年老店，品质卓越</p>
<p>• <strong>一保堂茶舗：</strong>京都百年茶铺，包装精美</p>
<p>• <strong>辻利：</strong>创立于1860年，抹茶甜品的代表品牌</p>
<p>• <strong>伊藤園：</strong>日本最大的茶饮品牌，品质稳定</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20matcha%20tea%20ceremony%20setting%20with%20bamboo%20whisk%20and%20ceramic%20bowl%2C%20green%20matcha%20powder%2C%20warm%20minimal%20tatami%20background%2C%20soft%20natural%20lighting%2C%20cultural%20photography&width=1200&height=675&seq=article-04&orientation=landscape',
    category: '食品零食',
    tags: ['抹茶', '日本文化', '茶道'],
    publishedAt: '2026-07-15',
    readTime: '9分钟',
    isFeatured: false,
  },
  {
    id: 5,
    slug: 'japanese-sunscreen-guide',
    title: '为什么日本防晒霜全球最好用？2026夏季防晒选购指南',
    excerpt: '日本防晒产品以轻薄不油腻的使用感和卓越的防护力闻名全球。本文解析日本防晒的技术优势，并推荐2026年夏季最值得入手的日系防晒产品。',
    content: `<p>每年夏天，日本防晒产品都会在全球范围内掀起抢购热潮。为什么日本防晒霜如此受欢迎？答案在于日本品牌在产品研发上的极致追求。</p>
<h3>日本防晒的技术优势</h3>
<p><strong>1. 轻薄质地：</strong>日本品牌率先攻克了高倍防晒油腻厚重的难题，通过微胶囊包裹技术和乳化工艺，使防晒霜质地如乳液般清爽。</p>
<p><strong>2. PA++++防护：</strong>日本是PA值体系（防护UVA能力的指标）的发源地，对UVA防护有着严格的标准。大部分日本防晒产品都能达到PA++++的最高等级。</p>
<p><strong>3. 护肤级配方：</strong>日系防晒通常会添加玻尿酸、胶原蛋白、神经酰胺等护肤成分，防晒同时滋养肌肤。</p>
<p><strong>4. 使用感极致优化：</strong>不泛白、不搓泥、不拔干、不闷痘，日本品牌对使用感的追求近乎偏执。</p>
<h3>2026年推荐日系防晒</h3>
<p><strong>• 安耐晒 金瓶（ANESSA Perfect UV Sunscreen）：</strong>户外防晒首选，遇水则强的黑科技，防水防汗效果一流。适合海边、户外运动等场景。</p>
<p><strong>• 碧柔 水感防晒（Biore UV Aqua Rich）：</strong>质地最轻薄的平价防晒，水感质地一秒化开，适合日常通勤使用。</p>
<p><strong>• 嘉娜宝 ALLIE防晒（ALLIE Extra UV Gel）：</strong>啫喱质地不油腻，添加美容液成分，面部和身体通用。</p>
<p><strong>• 黛珂防晒乳（COSME DECORTE Sun Shelter）：</strong>高端防晒首选，丝滑乳液质地，带有高级香氛气息，妆前打底效果出色。</p>
<p><strong>• 珂润防晒（Curel UV Protection）：</strong>专为敏感肌设计，无香料无酒精，添加神经酰胺修护肌肤屏障。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20sunscreen%20products%20arranged%20on%20a%20minimal%20surface%20with%20summer%20elements%2C%20beach%20background%20blur%2C%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20beauty%20product%20photography&width=1200&height=675&seq=article-05&orientation=landscape',
    category: '美妆护肤',
    tags: ['防晒', '护肤', '夏季'],
    publishedAt: '2026-07-10',
    readTime: '8分钟',
    isFeatured: false,
  },
  {
    id: 6,
    slug: 'japanese-stationery-guide',
    title: '日本文具到底好在哪？10款让人爱不释手的日系经典文具',
    excerpt: '日本文具以极致的细节设计和高品质的书写体验征服了全球文具爱好者。本文精选10款日系经典文具，从钢笔到手帐，感受日式匠心之美。',
    content: `<p>日本被称为"文具王国"，其对文具的重视程度和研发投入在全球范围内无人能及。以下10款日系经典文具，代表了日本在文具领域的最高工艺水平。</p>
<h3>1. 百乐 可擦笔 Frixion系列</h3>
<p>百乐的革命性产品，笔尾的橡胶头可以通过摩擦生热让墨水变透明，真正实现可擦除。如今已发展出圆珠笔、中性笔、荧光笔等全线产品。</p>
<h3>2. 三菱 UNI-ball Signo 307</h3>
<p>被誉为"世界上最好用的中性笔"，采用三菱独家的颜料墨水，防水不褪色，书写顺滑无比。0.38mm极细笔尖适合写小字。</p>
<h3>3. 斑马 SARASA Clip</h3>
<p>标志性的大号金属笔夹设计，墨水颜色丰富多达40+种，是手帐爱好者的必备良品。速干墨水不易晕染，左撇子也能轻松使用。</p>
<h3>4. 国誉 Campus笔记本</h3>
<p>日本学生人手一本的国民笔记本。纸张采用国誉独家造纸工艺，顺滑不洇墨，内页设计科学合理，有各种尺寸和行距可选。</p>
<h3>5. MIDORI MD手帐</h3>
<p>MIDORI出品的MD Paper被誉为"手帐纸的天花板"。奶油色纸张对眼睛友好，能够完美呈现钢笔的墨色和笔锋。</p>
<h3>6. 白金 3776世纪钢笔</h3>
<p>日本三大钢笔品牌之一白金出品的经典款，14K金尖带来极致的书写弹性。"滑封气帽"专利技术可防止墨水干涸长达24个月。</p>
<h3>7. HOBONICHI 手帐</h3>
<p>日本手帐文化代表品牌，每年限定封面设计引发抢购热潮。一天一页的设计理念和Tomoe River纸张的极致轻薄是其核心卖点。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20stationery%20collection%20beautifully%20arranged%20on%20a%20minimal%20wooden%20desk%2C%20fountain%20pens%2C%20notebooks%2C%20washi%20tape%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=1200&height=675&seq=article-06&orientation=landscape',
    category: '家居日用',
    tags: ['文具', '手帐', '日系设计'],
    publishedAt: '2026-07-05',
    readTime: '10分钟',
    isFeatured: false,
  },
];